import { action } from "satcheljs";
import type { SortColumn } from "owa-mail-list-store";
import type SortDirection from "owa-service/lib/contract/SortDirection";

/**
 * Action to set folder sort by settings
 */
export interface SetFolderSortByActionMessage {
    folderId: string;
    sortColumn: SortColumn;
    sortDirection: SortDirection;
}
const setFolderSortBy: (folderId: string, sortColumn: SortColumn, sortDirection: SortDirection) => SetFolderSortByActionMessage = action("setFolderSortBy", (folderId: string, sortColumn: SortColumn, sortDirection: SortDirection): SetFolderSortByActionMessage => ({
    folderId,
    sortColumn,
    sortDirection,
}));

export default setFolderSortBy;
